
import { Base } from '../base-component';

import './advanced-search.component.scss';

export class AdvancedSearch extends Base {

	modal: Element;
	openButton: Element;
	closeButton: Element;
	filterForm: HTMLFormElement;
	filterFormSubmitButton: Element;
	additionalFields: Element;
	additionalFieldsToggle: Element[];
	additionalFieldsOpenButton: Element;
	additionalFieldsOne: HTMLInputElement;
	additionalFieldsTwo: HTMLInputElement;

	constructor(element: Element) {
		super(element);
	}

	init() {

		this.modal = this.element.querySelector('.js-advanced-search-modal');
		this.openButton = this.element.querySelector('.js-advanced-search-modal-open');
		this.closeButton = this.element.querySelector('.js-advanced-search-modal-close');

		this.filterForm = this.element.querySelector('form');
		this.filterFormSubmitButton = this.element.querySelector('.js-submit-advanced-search-filter');

		this.additionalFields = this.element.querySelector('.js-advanced-search-additional');
		this.additionalFieldsToggle = Array.from(this.element.querySelectorAll('.js-advanced-search-additional-toggle'));
		this.additionalFieldsOne = <HTMLInputElement>this.element.querySelector('.js-advanced-search-additional-one');
		this.additionalFieldsTwo = <HTMLInputElement>this.element.querySelector('.js-advanced-search-additional-two');

		this.additionalFieldsOpenButton = this.element.querySelector('.js-advanced-search-additional-open');

		this.toggleAdditionalFieldsButtonStateOnAction('disable');

	}

	bindEvents() {

		this.element.addEventListener('click', (event) => this.isClickOutsideModal(event));

		this.openButton.addEventListener('click', (event) => this.openModal());
		this.closeButton.addEventListener('click', (event) => this.closeModal());

		this.filterFormSubmitButton.addEventListener('click', () => this.submitForm());

		this.additionalFieldsOne.addEventListener('input', () => this.toggleAdditionalFieldsButtonStateOnInput());

		this.additionalFieldsToggle.map((item) => item.addEventListener('click', (event) => {
			this.toggleAdditionalFields(event);
		}));

	}

	isClickOutsideModal(event) {

		if (event.target === this.modal) {
			this.closeModal();
		}

	}

	closeModal() {

		this.modal.classList.add('modal--close');

		setTimeout(() => {
			this.modal.classList.add('modal--closed');
		}, 250);

	}

	openModal() {

		this.modal.classList.remove('modal--close');
		this.modal.classList.remove('modal--closed');

	}

	toggleAdditionalFields(event) {

		if (event.currentTarget.classList.contains('button--disabled')) {
			return;
		}

		this.additionalFieldsTwo.value = '';

		if (this.additionalFields.classList.contains('advanced-search__additional--open')) {

			this.additionalFields.classList.remove('advanced-search__additional--open');
			this.toggleAdditionalFieldsButtonStateOnAction('enable');

		} else {

			this.additionalFields.classList.add('advanced-search__additional--open');
			this.toggleAdditionalFieldsButtonStateOnAction('disable');

		}

	}

	toggleAdditionalFieldsButtonStateOnAction(action) {

		if (action === 'disable') {
			this.additionalFieldsOpenButton.classList.add('button--disabled');
		} else {
			this.additionalFieldsOpenButton.classList.remove('button--disabled');
		}

	}

	toggleAdditionalFieldsButtonStateOnInput() {

		if (this.additionalFieldsOne.value !== '') {
			this.toggleAdditionalFieldsButtonStateOnAction('enable');
		} else {
			this.toggleAdditionalFieldsButtonStateOnAction('disable');
		}

	}

	submitForm() {

		console.log(this.serializeForm());

		this.closeModal();

	}

	serializeForm() {

		let field, result = [];

		if (typeof this.filterForm === 'object' && this.filterForm.nodeName === 'FORM') {

			const fieldsLen = this.filterForm.elements.length;

			for (let i = 0; i < fieldsLen; i++) {

				field = this.filterForm.elements[i];

				if (this.isOptionField(field)) {

					result[result.length] = {
						name: field.name,
						value: field.value
					};

				}

				if (this.isTextField(field)) {

					result[result.length] = {
						name: field.name,
						value: field.value
					};

				}

			}

		}

		return result;

	}

	isOptionField(field) {
		return ((field.type === 'checkbox' || field.type === 'radio') && field.checked);
	}

	isTextField(field) {
		return (field.type === 'text');
	}

}



// WEBPACK FOOTER //
// ./components/advanced-search/advanced-search.component.ts